/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { HistoryType, LocationType } from 'Type/Router.type';
import { setQueryParams } from 'Util/Url';

import YBCategoryPerfumes from './YBCategoryPerfumes.component';

/** @namespace Elganso/Component/YBCategoryPerfumes/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isMobile: state.ConfigReducer.device.isMobile
});

/** @namespace Elganso/Component/YBCategoryPerfumes/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({
});

/** @namespace Elganso/Component/YBCategoryPerfumes/Container */
export class YBCategoryPerfumesContainer extends PureComponent {
    static propTypes = {
        ...this.propTypes,
        getMedia: PropTypes.func.isRequired,
        getMediaByID: PropTypes.func.isRequired,
        history: HistoryType.isRequired,
        location: LocationType.isRequired
    };

    state = {

    };

    containerFunctions = {
        onPerfumesChildClick: this.onPerfumesChildClick.bind(this)
    };

    containerProps() {
        const {
            isMobile, children, getMedia, getMediaByID
        } = this.props;

        return {
            isMobile, children, getMedia, getMediaByID
        };
    }

    // componentDidMount() {
    // }

    onPerfumesChildClick(id) {
        const { history, location } = this.props;
        const filterUrl = `category_id:${id}`;

        setQueryParams({
            customFilters: filterUrl,
            page: ''
        }, location, history);
    }

    render() {
        return (
            <YBCategoryPerfumes
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(YBCategoryPerfumesContainer);
